import { LayoutGroup } from './LayoutGroup';

export class DynamicList extends LayoutGroup {
    protected maxHeight: number;

    constructor(height: number) {
        super();
        this.maxHeight = height;
    }

    protected buildLayout() {
        this.elements.sort((a, b) => b.width - a.width);
        const widest = this.elements[0];
        if (!widest) {
            return;
        }
        let columnWidth = 0;
        let totalHeight = 0;
        let totalWidth = 0;
        const vSpacing = 7;
        const hSpacing = 5;

        for (const element of this.elements) {
            if (totalHeight === 0) {
                columnWidth = element.width;
            }
            if (totalHeight + hSpacing + element.height >= this.maxHeight) {
                totalWidth += vSpacing + columnWidth;
                totalHeight = 0;
            }
            element.x = totalWidth;
            element.y = totalHeight + element.height / 2;
            totalHeight += hSpacing + element.height;
        }
    }
}
